import { useEffect, useState } from "react";

const HEX = /^#?[0-9a-f]{6}$/i;

export const ColorField = ({ id, label, value, onChange }) => {
  const [text, setText] = useState(value);
  const [bad, setBad] = useState(false);
  useEffect(() => { setText(value); setBad(false); }, [value]);
  const commit = (v) => {
    setText(v);
    if (HEX.test(v)) { setBad(false); onChange((v.startsWith("#") ? v : `#${v}`).toUpperCase()); }
  };
  return (
    <div className="flex items-center gap-3" data-testid={`color-field-${id}`}>
      <label className="relative h-10 w-10 shrink-0 cursor-pointer border-2 border-slate-900 shadow-[2px_2px_0_0_#0f172a]" style={{ background: value }}>
        <input type="color" value={value} onChange={(e) => commit(e.target.value)} className="absolute inset-0 h-full w-full cursor-pointer opacity-0"
          aria-label={`${label} picker`} data-testid={`color-${id}-picker`} />
      </label>
      <div className="min-w-0 flex-1">
        <div className="text-xs font-bold uppercase tracking-wider text-slate-600">{label}</div>
        <input value={text} maxLength={7} onChange={(e) => commit(e.target.value.trim())} onBlur={() => setBad(!HEX.test(text))}
          className={`font-mono-cc mt-0.5 w-28 border-b-2 bg-transparent py-0.5 text-sm uppercase outline-none ${bad ? "border-red-500" : "border-slate-200 focus:border-slate-900"}`}
          aria-label={`${label} HEX`} data-testid={`color-${id}-hex`} />
        {bad && <div className="text-xs text-red-600" data-testid={`color-${id}-error`}>Use a 6-digit HEX like #C8102E</div>}
      </div>
    </div>
  );
};
